import { createContext, useContext } from "react";

export const BotbPassDrawerContext = createContext<BotbPassDrawerContext>({
  allPackages: [],
  onClickClose: null,
  shouldShowDrawer: false,
  isDrawerOpen: false,
  setIsDrawerOpen: null,
  preSubscriptionData: null,
  preSubscriptionDataLoading: false,
  closeModal: null,
  overrideDesktopDisplaying: false,
});

export const useBotbPassDrawerContext = () => useContext(BotbPassDrawerContext);
